import React from 'react';
import styles from './NotificationTypeItem.module.scss';
const NotifcationTypeItem = ({ icon: Icon, label, description, iconClassName, onClick }: { icon: React.FC<React.SVGProps<SVGSVGElement>>, label: string, description: string, iconClassName?: string, onClick: () => void }) => {
    return (
        <div className={styles.container} onClick={onClick}>
            <div className={styles.headerContainer}>
                <span className={styles.title}>{label}</span>
                <span className={styles.description}> {description}</span>
            </div>

            <div className={`${styles.iconWrapper} ${iconClassName ?? ''}`}>
                <Icon />
            </div>
        </div>
    )
}

export default NotifcationTypeItem;
